<script setup>
defineProps({
  source: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <span
    class="border-4 inline-flex items-center w-4 h-4 rounded-l-xl rounded-r-lg"
    :class="{
      'border-blue-500': source === 'pts',
      'border-pink-500': source === 'sct',
    }"
  >&nbsp;</span>
</template>
